import styled from "styled-components";
import {LogOutLinkDefaultBox} from "./log-out-link.default.box";

export const LogOutLinkCasino777Box = styled(LogOutLinkDefaultBox)`
    padding: 1rem 0rem;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.4rem;
`;
